import { takeEvery } from "@redux-saga/core/effects";
import { FieldsActionTypes } from "./../types";
import { addFieldsSaga } from "./addField";
import { deleteFieldSaga } from "./deleteField";
import { duplicateFieldSaga } from "./duplicateField";
import { updateFieldSaga } from "./updateField";

export default function* fieldsSaga() {
    yield takeEvery(FieldsActionTypes.ADD_FIELD_REQUEST, addFieldsSaga);
    yield takeEvery(FieldsActionTypes.UPDATE_FIELD_REQUEST, updateFieldSaga);
    yield takeEvery(FieldsActionTypes.DELETE_FIELD_REQUEST, deleteFieldSaga);
    yield takeEvery(FieldsActionTypes.DUPLICATE_FIELD_REQUEST, duplicateFieldSaga);
}
